"use client";

import React from "react";
import { PrimaryButton } from "./PrimaryButton";

function cn(...classes: Array<string | false | undefined | null>) {
  return classes.filter(Boolean).join(" ");
}

function Divider({ text }: { text: string }) {
  return (
    <div className="my-5 flex items-center gap-3">
      <div className="h-px flex-1 bg-white/10" />
      <div className="text-xs text-white/45">{text}</div>
      <div className="h-px flex-1 bg-white/10" />
    </div>
  );
}

interface SocialButtonProps {
  provider: "google" | "microsoft";
  onClick?: () => void;
}

export function SocialButton({ provider, onClick }: SocialButtonProps) {
  const label = provider === "google" ? "Continue with Google" : "Continue with Microsoft";
  
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "h-11 w-full rounded-xl border border-white/10 bg-white/[0.03]",
        "text-sm font-semibold text-white/80",
        "hover:bg-white/[0.06] hover:text-white transition"
      )}
    >
      {label}
    </button>
  );
}

export { Divider, PrimaryButton };

